import { Services, regExp } from '@sigma-frontend-libs/commons'

import { buttonModes, components, icons } from '@/utils'

import button from '@/components/button'

function renderPasswordFiled(h) {
  let passwordType
  let passwordAfterIcon
  if (this.passwordVisibility) {
    passwordType = 'password'
    passwordAfterIcon = icons.visibility
  } else {
    passwordType = 'text'
    passwordAfterIcon = icons.visibility_off
  }

  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy,
        defaultValue: undefined,
        label: this.getTranslate(`${Services.users}.labels.password`),
        hint: this.hint,
        error: this.errors.password || this.error,
        name: 'password',
        autocomplete: this.autocomplete,
        type: passwordType,
        afterIcon: passwordAfterIcon,
        afterIconCallback: () => {
          return this.passwordVisibility = !this.passwordVisibility
        },
        mask: regExp.password,
        dense: true,
        required: true,
        clearable: true,
        details: this.isRegistration,
        tabindex: 2
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    }
  )
}

function renderGeneratePasswordButton(h) {
  return h(
    button,
    {
      props: {
        icon: icons.settings_backup_restore,
        mode: buttonModes.flat,
        tooltip: this.getTranslate(`${Services.users}.tooltips.generate.password`),
        tabindex: -1
      },
      on: {
        click: () => {
          this.passwordGenerator()
        }
      }
    }
  )
}

export default function(h) {
  if (this.editable || this.isNew || this.isRegistration) {
    return h(
      'div',
      {
        class: `${Services.users}-form__password`
      },
      [
        renderPasswordFiled.call(this, h),
        renderGeneratePasswordButton.call(this, h)
      ]
    )
  } else {
    return h(
      button,
      {
        props: {
          label: this.getTranslate(`${Services.users}.buttons.password`),
          mode: buttonModes.flat,
          tabindex: 2
        },
        on: {
          click: () => {
            this.editable = true
          }
        }
      }
    )
  }
}
